module.exports = __webpack_public_path__ + "static/media/distance-icon.1f8e3db4.svg";